import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// 全局配置
Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'medium' })

// Axios 全局配置
// axios.defaults.baseURL = process.env.VUE_APP_API_BASE || '/api'
// axios.defaults.timeout = 15000

// 请求拦截器 - 注入 Token
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器 - 统一处理错误
axios.interceptors.response.use(response => {
  const res = response.data
  if (res.code && res.code !== 200 && res.code !== 0) {
    Vue.prototype.$message.error(res.message || '请求失败')
    return Promise.reject(res)
  }
  return res
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        Vue.prototype.$message.error('登录已过期，请重新登录')
        localStorage.removeItem('token')
        router.push('/login')
        break
      case 403:
        Vue.prototype.$message.error('没有权限访问')
        break
      case 404:
        Vue.prototype.$message.error('请求资源不存在')
        break
      case 500:
        Vue.prototype.$message.error('服务器内部错误')
        break
      default:
        Vue.prototype.$message.error(error.response.data.message || '网络错误')
    }
  } else {
    Vue.prototype.$message.error('网络连接失败')
  }
  return Promise.reject(error)
})

Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
